// --- React libraries ---
import type { LucideIcon } from 'lucide-react';
import { PanelsTopLeft, Sparkles, LifeBuoy } from 'lucide-react';

// --- shared components ---
import { NAV_ITEMS, CATEGORY_ORDER } from '../constants';

// --- types ---
import type { NavItem } from '../types';
import { NavCategory } from '../types';

export type NavSectionPlacement = 'main' | 'footer' | 'help';

export interface NavSection {
  id: string;
  label: string;
  items: NavItem[];
  placement: NavSectionPlacement;
  icon: LucideIcon;
  category?: NavCategory;
}

const createNavSections = () => {
  const sections: NavSection[] = [];

  sections.push({
    id: 'module-center',
    label: 'Module Center',
    items: NAV_ITEMS,
    placement: 'main',
    icon: PanelsTopLeft
  });

  CATEGORY_ORDER.filter(category => category !== NavCategory.SALES).forEach(category => {
    const items = NAV_ITEMS.filter(item => item.category === category);
    if (!items.length) return;
    const slug = category.toLowerCase();
    sections.push({
      id: slug,
      label: category,
      items,
      placement: 'main',
      icon: items[0]?.icon ?? PanelsTopLeft,
      category
    });
  });

  const helpItems = NAV_ITEMS.filter(item => item.category === NavCategory.SALES);
  sections.push({
    id: 'help',
    label: 'Help Center',
    items: helpItems,
    placement: 'help',
    icon: LifeBuoy
  });



  const main = sections.filter(section => section.placement === 'main');
  const footer = sections.filter(section => section.placement === 'footer');
  const map = Object.fromEntries(sections.map(section => [section.id, section]));

  return { sections, main, footer, map };
};

const navSectionsCache = createNavSections();

export const NAV_SECTIONS = navSectionsCache.sections;
export const MAIN_NAV_SECTIONS = navSectionsCache.main;
export const FOOTER_NAV_SECTIONS = navSectionsCache.footer;
export const NAV_SECTIONS_MAP = navSectionsCache.map;
